export default "__VITE_ASSET__D0B1iVnv__"